import { useParams } from 'react-router-dom';
import Header from '../components/layout/Header';
import { Icon } from '@iconify/react';
import AnimatedSection from '../components/ui/AnimatedSection';

const seoData: Record<string, { titulo: string; descripcion: string }> = {
  'agente-ia-whatsapp': {
    titulo: 'Agente IA para WhatsApp | Automatización 24/7',
    descripcion: 'Implementa un agente de IA en WhatsApp que responde clientes, consulta stock, genera cotizaciones y agenda reuniones de forma automática.',
  },
  'software-para-retail': {
    titulo: 'Software para Retail | Gestión de tiendas',
    descripcion: 'Sistema de gestión para retail con control de inventario, ventas, caja y reportes. Especialistas en retail en Perú.',
  },
  'software-para-ecommerce': {
    titulo: 'Software para Ecommerce | Tienda online con IA',
    descripcion: 'Creamos tiendas online inteligentes con pasarela de pago, integración logística y agente IA para atención al cliente.',
  },
  'desarrollo-software-peru': {
    titulo: 'Desarrollo de Software en Perú | Scalar',
    descripcion: 'Empresa de desarrollo de software en Perú. Creamos sistemas web, móviles y ERP con tecnologías modernas e IA.',
  },
  'erp-para-pymes': {
    titulo: 'ERP para Pymes | Sistema de gestión empresarial',
    descripcion: 'ERP personalizado para pequeñas y medianas empresas. Control de inventario, ventas, caja, reportes y dashboard.',
  },
  'automatizacion-con-ia': {
    titulo: 'Automatización con IA | Procesos inteligentes',
    descripcion: 'Automatizamos procesos empresariales con inteligencia artificial. Agentes IA, chatbots y automatización documental.',
  },
};

export default function SeoPage() {
  const { slug } = useParams<{ slug: string }>();
  const data = slug ? seoData[slug] : null;

  if (!data) return null;

  return (
    <>
      <Header />
      <main className="bg-[#f5f5f7] text-[#2d2d44]">
        <AnimatedSection as="section" className="py-24">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-[#f26724] leading-tight mb-6">{data.titulo}</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed">{data.descripcion}</p>
            <a href={"https://api.whatsapp.com/send?phone=51946564003&text=Quiero%20informaci%C3%B3n%20sobre%20" + encodeURIComponent(data.titulo)} className="inline-flex items-center gap-2 px-8 py-4 bg-[#f26724] text-black font-semibold rounded-xl hover:bg-[#f3823c] transition-all hover:shadow-lg hover:shadow-[#f26724]/20" target="_blank" rel="noopener noreferrer">
              Solicitar información <Icon icon="mdi:arrow-right" className="text-xl" />
            </a>
          </div>
        </AnimatedSection>
      </main>
    </>
  );
}
